export default {
    isTablet() {
      const w = window.innerWidth;
  
      return w < 1200 && w >= 768;
    }
  };
  